import React from "react";
import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

import InternalChatInfo from "../InternalChatInfo";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    backgroundColor: theme.palette.background.paper,
    flex: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
  },
}));

const InternalChatHeader = ({ loading, chat, user }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleBack = () => {
    history.push("/internal-chats");
  };

  if (loading) {
    return (
      <Card square className={classes.ticketHeader}>
        <Button color="primary" onClick={handleBack}>
          <ArrowBackIos />
        </Button>
        <div style={{ flex: 1, padding: "16px 8px" }} />
      </Card>
    );
  }

  return (
    <Card square className={classes.ticketHeader}>
      <Button color="primary" onClick={handleBack}>
        <ArrowBackIos />
      </Button>
      <InternalChatInfo chat={chat} user={user} />
    </Card>
  );
};

export default InternalChatHeader;
